import { mapGetters } from 'vuex'
import { Utils } from 'trading-vue-js'

export default {
    data(){
        return {
            settingsJson:'',
            gridRef:'',
            timeFrameData:"",
            saveTimeFrame:"",
        }
    },
    methods:{
        registerMouseEvent(self){
            self.mouse.on('mouseup',(e)=>{
                this.saveSettings(self)
            })
        },
        saveSettings(self){

            let uid = self.$props.settings.$uuid

            if("finished" === self.$props.settings.$state){
                let currentSettings = self.$props.settings;
                //  if (currentSettings.p1 && currentSettings.p1[2] !== undefined) {
                //     if (!self.layout || !self.layout.ti_map) return;
                //     let idx = self.layout.ti_map.t2i(currentSettings.p1[2]);
                //     if (idx === undefined || isNaN(idx)) return; // Don't save if layout is not ready
                // }
                // if (currentSettings.p2 && currentSettings.p2[2] !== undefined) {
                //     if (!self.layout || !self.layout.ti_map) return;
                //     let idx = self.layout.ti_map.t2i(currentSettings.p2[2]);
                //     if (idx === undefined || isNaN(idx)) return; // Don't save if layout is not ready
                // }
                if(!self.$props.settings?.drawingId){
                    let uuidGenerated = Utils.uuid2()
                    self.$props.settings.drawingId = uuidGenerated
                }
                let {$selected, ...currentSettingsData} = currentSettings;
                let currentSettingsJson = JSON.stringify(currentSettingsData)
                let changeOccurs = false
                if (currentSettingsJson !== self.settingsJson) {
                    changeOccurs = true
                    self.settingsJson = currentSettingsJson
                }
                if(changeOccurs){
                    self.timeFrameData =this.timeFrame
                    self.$emit('line-is-changed',uid,self.gridRef,self.timeFrameData)
                }
            }
        },
        updateSettingsState(self,trn){
            try{
                let settings = self.$props.settings;
                let tiMap = self.layout.ti_map;
                
                if (tiMap && tiMap.sub && tiMap.sub.length > 0) {
                    let t0 = tiMap.sub[0][0];
                    let tN = tiMap.sub[tiMap.sub.length - 1][0];
                    if (settings.p1 && settings.p1[2] !== undefined) {
                        let t = settings.p1[2];
                        if (t >= t0 && t <= tN) {
                            let idx = tiMap.t2i(t);
                            if (idx !== undefined && !isNaN(idx) && settings.p1[0] !== idx) {
                                settings.p1[0] = idx;
                            }
                        }
                    }
                    if (settings.p2 && settings.p2[2] !== undefined) {
                        let t = settings.p2[2];
                        if (t >= t0 && t <= tN) {
                            let idx = tiMap.t2i(t);
                            if (idx !== undefined && !isNaN(idx) && settings.p2[0] !== idx) {
                                settings.p2[0] = idx;
                            }
                        }
                    }
                    if (settings.p3 && settings.p3[2] !== undefined) {
                        let t = settings.p3[2];
                        if (t >= t0 && t <= tN) {
                            let idx = tiMap.t2i(t);
                            if (idx !== undefined && !isNaN(idx) && settings.p3[0] !== idx) {
                                settings.p3[0] = idx;
                            }
                        }
                    }
                    if (settings.brushStrokes && settings.brushStrokes.length > 0) {
                        for (let point of settings.brushStrokes) {
                            if (point[2] !== undefined) {
                                let idx = tiMap.t2i(point[2]);
                                if (idx !== undefined && !isNaN(idx)) {
                                    point[0] = idx;
                                }
                            }
                        }
                    }
                }
                let gridRef = settings.gridRef;
                if(self.$props.grid_id && !gridRef && self.$props.cursor && self.$props.cursor.values && Object.keys(self.$props.cursor.values).length > 0){
                    let gridValues = Object.keys(self.$props.cursor.values[self.$props.grid_id])
                    for (let gridValue of gridValues) {
                        if(gridValue !== "ohlcv"){
                            gridRef = gridValue.split("_")[0]
                            break;
                        }
                    }
                }
                let {$selected, ...settingsJson} = settings;
                self.settingsJson = JSON.stringify(settingsJson)
                self.gridRef = gridRef
                self.timeFrameData = this.timeFrame
                return true
            }catch (e) {
                return false
            }
        },
    },
    created() {
    },
     watch: {
        layout: {
            handler() {
                this.updateSettingsState(this);
            },
            deep: false
        }
    },
    computed:{
        ...mapGetters(['timeFrame',"drawingDataSaveSettings"]),
        uuidData() {
            return `${this.sett?.$uuid}`
        },
        savedSettings(){
            return this.drawingDataSaveSettings[this.uuidData]
        },
    }
}
